import Model from '@/store/plugins/orm/Model'

export class Shortcut extends Model {
    static get entity () {
        return 'shortcuts'
    }

    static fields () {
        return {
            id: this.attr(null),
            name: this.attr(null),
            value: this.attr(null),
        }
    }
}

export default Shortcut
